module.exports = __webpack_public_path__ + "static/img/04.cb51b4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/04/04.jpg
// module id = w7Ya
// module chunks = 0